export default "__VITE_ASSET__CHfoXUnH__"